import React from 'react';
import { X } from 'lucide-react';

export default function UserSummaryModal({ isOpen, onClose, summary }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-screen items-center justify-center px-4">
                <div className="fixed inset-0 bg-black opacity-30" onClick={onClose}></div>
                <div className="relative bg-white dark:bg-gray-800 rounded-lg max-w-2xl w-full max-h-[75vh] flex flex-col">
                    <div className="flex justify-between items-center p-6 border-b border-gray-200 dark:border-gray-700">
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                            Resumo do Usuário
                        </h3>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                    <div className="p-6 overflow-y-auto">
                        <div className="prose dark:prose-invert max-w-none">
                            <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 whitespace-pre-wrap font-mono text-sm dark:text-white">
                                {summary}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}